var map = {
	"./book.svg": "c8e3",
	"./bulb.svg": "b12f",
	"./chip-close.svg": "0c04",
	"./circle-play-icon.svg": "779d",
	"./close-icon.svg": "7ddb",
	"./close.svg": "bf37",
	"./contact-number-icon.svg": "ae36",
	"./down-arrow.svg": "8c3e",
	"./download-meduim-icon.svg": "52c0",
	"./download-mobile.svg": "422a",
	"./download-small-icon.svg": "e6b4",
	"./email-icon.svg": "0c52",
	"./faqs-icon.svg": "c070",
	"./glossary icon.svg": "c571",
	"./glossary.svg": "bfd1",
	"./helpful-hints-icon.svg": "99af",
	"./left-arrow.svg": "c012",
	"./leverage-1.png": "b74f",
	"./leverage-2.png": "5a96",
	"./list.svg": "e7e9",
	"./logo.svg": "9b19",
	"./message-primary.svg": "3ed5",
	"./message-white.svg": "d740",
	"./open-new-tab-icon.svg": "c84f",
	"./play-icon.svg": "c0c8",
	"./poster.png": "14ae",
	"./quick-guides-icon.svg": "b549",
	"./right-arrow.svg": "f590",
	"./search-icon.svg": "d8e7",
	"./up-arrow.svg": "0d36",
	"./video-placeholder-icon.svg": "b95d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";